(function () {
  'use strict';

  var widget = document.getElementById('lipsell-reviews-widget');
  if (!widget) return;

  var API = widget.dataset.api;
  var handle = widget.dataset.handle;
  var productId = widget.dataset.productId || '';
  var domainLang = (function(h) {
    if (/\.lv(\/|$)/.test(h)) return 'lv';
    if (/\.ee(\/|$)/.test(h)) return 'et';
    if (/\.(de)(\/|$)/.test(h)) return 'de';
    if (/\.(at|ch)(\/|$)/.test(h)) return 'de';
    if (/\.fr(\/|$)/.test(h)) return 'fr';
    if (/\.es(\/|$)/.test(h)) return 'es';
    if (/\.pl(\/|$)/.test(h)) return 'pl';
    if (/\.nl(\/|$)/.test(h)) return 'nl';
    if (/\.be(\/|$)/.test(h)) return 'nl';
    if (/\.dk(\/|$)/.test(h)) return 'da';
    if (/\.se(\/|$)/.test(h)) return 'sv';
    if (/\.fi(\/|$)/.test(h)) return 'fi';
    if (/\.cz(\/|$)/.test(h)) return 'cs';
    if (/\.ro(\/|$)/.test(h)) return 'ro';
    if (/\.gr(\/|$)/.test(h)) return 'el';
    if (/\.pt(\/|$)/.test(h)) return 'pt';
    if (/\.it(\/|$)/.test(h)) return 'it';
    if (/\.(co\.uk|com|shop)(\/|$)/.test(h)) return 'en';
    return 'lt';
  })(location.hostname);

  var productVendor = widget.dataset.productVendor || '';
  var productTitle = (productVendor ? productVendor + ' ' : '') + (widget.dataset.productTitle || '');
  var i18n = {

    helpful: widget.dataset.i18nHelpful,
    sortLabel: widget.dataset.i18nSortLabel,
    sortNewest: widget.dataset.i18nSortNewest,
    sortOldest: widget.dataset.i18nSortOldest,
    sortBest: widget.dataset.i18nSortBest,
    sortWorst: widget.dataset.i18nSortWorst,
    noReviews: widget.dataset.i18nNoReviews,
    loadMore: widget.dataset.i18nLoadMore,
    outOf5: widget.dataset.i18nOutOf5,
    photo: widget.dataset.i18nPhoto || 'nuotrauka',
    translate: widget.dataset.i18nTranslate || 'Išversti',
    showOriginal: widget.dataset.i18nShowOriginal || 'Rodyti originalą',
  };

  var LOAD_ERR = {
    lt: 'Atsiliepimų nepavyko įkelti. Bandykite vėliau.',
    lv: 'Neizdevās ielādēt atsauksmes. Lūdzu, mēģiniet vēlāk.',
    et: 'Arvustusi ei õnnestunud laadida. Palun proovige hiljem uuesti.',
    en: "Reviews couldn't be loaded right now. Please try again later.",
    de: 'Bewertungen konnten nicht geladen werden. Bitte später erneut versuchen.',
    fr: 'Impossible de charger les avis. Veuillez réessayer plus tard.',
    es: 'No se pudieron cargar las reseñas. Inténtalo de nuevo más tarde.',
    it: 'Impossibile caricare le recensioni. Riprova più tardi.',
    nl: 'Recensies konden niet worden geladen. Probeer het later opnieuw.',
    pl: 'Nie udało się załadować opinii. Spróbuj ponownie później.',
    cs: 'Recenze se nepodařilo načíst. Zkuste to prosím později.',
    da: 'Anmeldelserne kunne ikke indlæses. Prøv igen senere.',
    sv: 'Det gick inte att ladda recensionerna. Försök igen senare.',
    fi: 'Arvostelujen lataaminen epäonnistui. Yritä myöhemmin uudelleen.',
    ro: 'Recenziile nu au putut fi încărcate. Încercați din nou mai târziu.',
    el: 'Δεν ήταν δυνατή η φόρτωση των κριτικών. Δοκιμάστε ξανά αργότερα.',
    pt: 'Não foi possível carregar as avaliações. Tente novamente mais tarde.',
  };

  var state = { sort: 'newest', page: 1, limit: 10, total: 0, pages: 0, stats: null, imgCounter: 0 };
  var VOTED_KEY = 'lipsell_helpful_voted';
  function loadVoted() { try { return new Set(JSON.parse(localStorage.getItem(VOTED_KEY) || '[]')); } catch(e) { return new Set(); } }
  function saveVoted(id, voted) { var s = loadVoted(); if (voted) s.add(id); else s.delete(id); try { localStorage.setItem(VOTED_KEY, JSON.stringify([...s])); } catch(e) {} }
  var votedIds = {};

  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  var FLAG_CDN = {
    be:'be.svg?v=1723143690', cz:'cz.svg?v=1723144137', dk:'dk.svg?v=1723144138', de:'de.svg?v=1723144138',
    ee:'ee.svg?v=1723144137', gr:'gr.svg?v=1723144138', gb:'gb.svg?v=1723144138', es:'es.svg?v=1723144139',
    fr:'fr.svg?v=1723144137', it:'it.svg?v=1723144138', lv:'lv.svg?v=1723144137', lt:'lt.svg?v=1723144137',
    nl:'nl.svg?v=1723144138', at:'at.svg?v=1723144138', pl:'pl.svg?v=1723144137', ro:'ro.svg?v=1723144138',
    ch:'ch.svg?v=1723144138', fi:'fi.svg?v=1723144137', se:'se.svg?v=1723144138',
  };
  function flagEmoji(cc) {
    if (!cc || cc.length !== 2) return '';
    var A = 0x1F1E6 - 'A'.charCodeAt(0);
    return String.fromCodePoint(cc.charCodeAt(0) + A) + String.fromCodePoint(cc.charCodeAt(1) + A);
  }
  function flag(country) {
    if (!country) return '';
    var cc = String(country).toLowerCase();
    if (FLAG_CDN[cc]) {
      return '<img src="https://cdn.shopify.com/s/files/1/0568/7495/8892/files/' + FLAG_CDN[cc] + '" alt="' + esc(cc.toUpperCase()) + '" width="18" height="14" style="display:inline-block;vertical-align:middle;border-radius:2px" loading="lazy">';
    }
    return '<span aria-label="' + esc(cc.toUpperCase()) + '" style="font-size:14px;line-height:1">' + flagEmoji(cc.toUpperCase()) + '</span>';
  }

  function stars(rating, size) {
    size = size || 18;
    var s = '<span style="display:inline-flex;gap:1px;align-items:center">';
    for (var i = 1; i <= 5; i++) {
      s += '<span style="color:' + (i <= rating ? '#f5a623' : '#ddd') + ';font-size:' + size + 'px;line-height:0;position:relative;top:-3px">&#9733;</span>';
    }
    return s + '</span>';
  }

  function renderStats(stats) {
    if (!stats) return '';
    var bars = '';
    for (var r = 5; r >= 1; r--) {
      var count = stats.distribution[String(r)] || 0;
      var pct = stats.count > 0 ? Math.round(count / stats.count * 100) : 0;
      bars +=
        '<div style="display:flex;align-items:center;gap:8px;margin-bottom:4px">' +
          '<span style="font-size:13px;width:10px;text-align:right;color:#555">' + r + '</span>' +
          '<span style="font-size:16px;line-height:0;color:#f5a623;position:relative;top:-2px">&#9733;</span>' +
          '<div style="flex:1;background:#eee;border-radius:3px;height:5px">' +
            '<div style="width:' + pct + '%;background:#f5a623;height:5px;border-radius:3px"></div>' +
          '</div>' +
          '<span style="font-size:12px;color:#888;min-width:20px;text-align:right">' + count + '</span>' +
        '</div>';
    }
    return (
      '<div style="display:flex;gap:32px;align-items:center;padding:20px 0 24px;border-bottom:1px solid #eee;margin-bottom:20px">' +
        '<div style="text-align:center;min-width:80px">' +
          '<div style="font-size:48px;font-weight:700;line-height:1;color:#111">' + stats.avg.toFixed(1) + '</div>' +
          '<div style="margin:4px 0">' + stars(Math.round(stats.avg), 16) + '</div>' +
          '<div style="font-size:12px;color:#888">' + esc(i18n.outOf5) + '</div>' +
        '</div>' +
        '<div style="flex:1">' + bars + '</div>' +
      '</div>'
    );
  }

  function renderReview(r) {
    var date = new Date(r.created_at).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    var helpful = r.helpful_count > 0
      ? '<span id="rev-helpful-count-' + r.id + '" style="font-size:11px;margin-left:3px">' + r.helpful_count + '</span>'
      : '';
    return (
      '<div style="padding:16px 0;border-bottom:1px solid #f0f0f0">' +
        '<div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;min-height:28px">' +
          stars(r.rating, 16) +
          (r.title ? '<span id="rev-title-' + r.id + '" style="font-size:15px;font-weight:600;color:#111">' + esc(r.title) + '</span>' : '') +
        '</div>' +
        '<p id="rev-body-' + r.id + '" style="font-size:14px;color:#333;margin:0 0 10px;line-height:1.6">' + esc(r.body) + '</p>' +
        (r.images && r.images.length ? '<div style="display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px">' + r.images.map(function(img, idx){ var n = ++state.imgCounter; return '<button type="button" class="rev-img-btn" data-src="'+esc(img)+'" data-imgs="'+esc(JSON.stringify(r.images))+'" data-idx="'+idx+'" style="background:none;border:none;padding:0;cursor:zoom-in"><img src="'+esc(img)+'" alt="'+(productTitle ? esc(productTitle)+' – '+esc(i18n.photo)+' '+n : esc(i18n.photo)+' '+n)+'" loading="lazy" style="width:64px;height:64px;object-fit:cover;border-radius:4px;border:1px solid #eee"></button>';}).join('')+'</div>' : '') +
        (r.owner_response
          ? '<div style="background:#f9f9f9;border-left:3px solid #ccc;padding:8px 12px;margin-bottom:10px;font-size:13px;color:#444">' + esc(r.owner_response) + '</div>'
          : '') +
        '<div style="display:flex;align-items:center;gap:16px;flex-wrap:wrap">' +
          '<span style="font-size:13px;font-weight:600;color:#222;display:inline-flex;align-items:center;gap:6px">' + esc(r.customer_name) + flag(r.country) + '</span>' +
          '<span style="font-size:12px;color:#aaa">' + date + '</span>' +
          '<button data-id="' + r.id + '" data-voted="' + (r.voted ? '1' : '') + '" class="rev-helpful-btn" style="margin-left:auto;background:none;border:1px solid #ddd;border-radius:12px;padding:4px 10px;cursor:pointer;display:inline-flex;align-items:center;gap:3px;color:#aaa;transition:color .15s,border-color .15s">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="flex-shrink:0"><path d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 9.45 7 10v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"/></svg>' +
            helpful +
          '</button>' +
        '</div>' +
        (r.language && r.language !== domainLang
          ? '<button data-id="' + r.id + '" data-from="' + esc(r.language) + '" data-title="' + esc(r.title || '') + '" data-body="' + esc(r.body) + '" class="rev-translate-btn" style="margin-top:8px;background:none;border:none;padding:0;font-size:12px;color:#888;cursor:pointer;text-decoration:underline">' + esc(i18n.translate) + '</button>'
          : '') +
      '</div>'
    );
  }

  function load(append) {
    fetch(API + '/reviews/' + encodeURIComponent(handle) + '?sort=' + state.sort + '&page=' + state.page + '&limit=' + state.limit + (productId ? '&product_id=' + encodeURIComponent(productId) : ''))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        state.total = data.total;
        state.pages = data.pages;
        state.stats = data.stats;
        render(data.reviews, append);
      })
      .catch(function () {
        if (!append) {
          widget.innerHTML = '<p style="color:#aaa;font-size:14px;padding:16px 0">' + esc(LOAD_ERR[domainLang] || LOAD_ERR.en) + '</p>';
        }
      });
  }

  function render(reviews, append) {
    if (!append) {
      var statsHtml = renderStats(state.stats);
      var controls =
        '<div style="display:flex;align-items:center;justify-content:flex-end;margin-bottom:16px">' +
          '<label style="font-size:13px;color:#666;margin-right:8px">' + esc(i18n.sortLabel) + '</label>' +
          '<select id="rev-sort" style="font-size:13px;border:1px solid #ddd;border-radius:4px;padding:4px 8px;background:#fff">' +
            '<option value="newest"' + (state.sort === 'newest' ? ' selected' : '') + '>' + esc(i18n.sortNewest) + '</option>' +
            '<option value="oldest"' + (state.sort === 'oldest' ? ' selected' : '') + '>' + esc(i18n.sortOldest) + '</option>' +
            '<option value="best"' + (state.sort === 'best' ? ' selected' : '') + '>' + esc(i18n.sortBest) + '</option>' +
            '<option value="worst"' + (state.sort === 'worst' ? ' selected' : '') + '>' + esc(i18n.sortWorst) + '</option>' +
          '</select>' +
        '</div>';

      widget.innerHTML = statsHtml + controls + '<div id="rev-list"></div><div id="rev-load-more-wrap" style="text-align:center;padding:16px 0"></div>';

      document.getElementById('rev-sort').addEventListener('change', function (e) {
        state.sort = e.target.value;
        state.page = 1;
        load(false);
      });
    }

    var list = document.getElementById('rev-list');
    if (!list) return;

    if (!append) { list.innerHTML = ''; state.imgCounter = 0; }

    if (reviews.length === 0 && !append && state.total === 0) {
      list.innerHTML = '<p style="color:#aaa;font-size:14px;padding:16px 0">' + esc(i18n.noReviews) + '</p>';
    } else {
      reviews.forEach(function (r) {
        list.insertAdjacentHTML('beforeend', renderReview(r));
      });
      bindHelpful();
      bindImageBtns();
      bindTranslate();
    }

    var wrap = document.getElementById('rev-load-more-wrap');
    if (wrap) {
      if (state.page < state.pages) {
        wrap.innerHTML = '<button id="rev-load-more" style="background:none;border:1px solid #ddd;border-radius:4px;padding:8px 24px;font-size:14px;cursor:pointer;color:#444">' + esc(i18n.loadMore) + '</button>';
        document.getElementById('rev-load-more').addEventListener('click', function () {
          state.page++;
          load(true);
        });
      } else {
        wrap.innerHTML = '';
      }
    }
  }

  function openLightbox(imgs, startIdx) {
    var idx = startIdx;
    var overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:99999;display:flex;align-items:center;justify-content:center';

    function render() {
      overlay.innerHTML =
        '<button style="position:absolute;top:16px;right:20px;background:none;border:none;color:#fff;font-size:32px;cursor:pointer;line-height:1" id="lb-close">&times;</button>' +
        (imgs.length > 1 ? '<button style="position:absolute;left:12px;background:none;border:none;color:#fff;font-size:40px;cursor:pointer;line-height:1;padding:8px" id="lb-prev">&#8249;</button>' : '') +
        '<img src="'+esc(imgs[idx])+'" style="max-width:90vw;max-height:85vh;object-fit:contain;border-radius:4px" alt="Atsiliepimo nuotrauka">' +
        (imgs.length > 1 ? '<button style="position:absolute;right:12px;background:none;border:none;color:#fff;font-size:40px;cursor:pointer;line-height:1;padding:8px" id="lb-next">&#8250;</button>' : '') +
        (imgs.length > 1 ? '<div style="position:absolute;bottom:16px;color:#ccc;font-size:13px">'+(idx+1)+' / '+imgs.length+'</div>' : '');
      document.getElementById('lb-close').onclick = function() { document.body.removeChild(overlay); };
      if (document.getElementById('lb-prev')) document.getElementById('lb-prev').onclick = function() { idx = (idx - 1 + imgs.length) % imgs.length; render(); };
      if (document.getElementById('lb-next')) document.getElementById('lb-next').onclick = function() { idx = (idx + 1) % imgs.length; render(); };
    }

    overlay.addEventListener('click', function(e) { if (e.target === overlay) document.body.removeChild(overlay); });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { document.body.removeChild(overlay); document.removeEventListener('keydown', onKey); }
      if (e.key === 'ArrowLeft') { idx = (idx - 1 + imgs.length) % imgs.length; render(); }
      if (e.key === 'ArrowRight') { idx = (idx + 1) % imgs.length; render(); }
    });

    document.body.appendChild(overlay);
    render();
  }

  function bindTranslate() {
    document.querySelectorAll('.rev-translate-btn').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      var id = btn.dataset.id;
      var translated = false;
      var origTitle = btn.dataset.title;
      var origBody = btn.dataset.body;

      btn.addEventListener('click', function () {
        if (translated) {
          var titleEl = document.getElementById('rev-title-' + id);
          var bodyEl = document.getElementById('rev-body-' + id);
          if (titleEl) titleEl.textContent = origTitle;
          if (bodyEl) bodyEl.textContent = origBody;
          // textContent pats ekranuoja, todel esc() cia butu dvigubas ekranavimas
          btn.textContent = i18n.translate;
          translated = false;
          return;
        }

        btn.textContent = '...';
        var from = btn.dataset.from;
        var texts = [origBody];
        if (origTitle) texts.unshift(origTitle);
        var joined = texts.join('\n\n');

        // MyMemory kartais atsako per 10-15 s. Be laikmacio mygtukas amziams likdavo
        // ties "...", ir atrodydavo, kad vertimas neveikia. Nutraukiam po 12 s ir
        // grazinam uzrasa, kad zmogus galetu bandyti dar karta.
        var ctl = window.AbortController ? new AbortController() : null;
        var killer = setTimeout(function () { if (ctl) ctl.abort(); }, 12000);
        var opts = ctl ? { signal: ctl.signal } : {};
        // de= pakelia nemokama dienos riba nuo 5 000 iki 50 000 simboliu vienam IP
        fetch('https://api.mymemory.translated.net/get?q=' + encodeURIComponent(joined) +
              '&langpair=' + encodeURIComponent(from + '|' + domainLang) +
              '&de=' + encodeURIComponent('info@lipsell.lt'), opts)
          .then(function (res) { clearTimeout(killer); return res.json(); })
          .then(function (data) {
            var result = data.responseData && data.responseData.translatedText;
            // Isnaudojus dienos kvota MyMemory grazina 200, o i translatedText ideda
            // ispejima didziosiomis raidemis. Be sios patikros tas ispejimas budavo
            // irasomas vietoj atsiliepimo teksto.
            var failed = !result || data.responseStatus !== 200 ||
                         /^MYMEMORY WARNING|QUERY LENGTH LIMIT|INVALID (SOURCE|TARGET) LANGUAGE/i.test(result);
            if (failed) { btn.textContent = i18n.translate; return; }
            var parts = result.split('\n\n');
            if (origTitle) {
              var titleEl = document.getElementById('rev-title-' + id);
              var bodyEl = document.getElementById('rev-body-' + id);
              if (titleEl) titleEl.textContent = parts[0] || origTitle;
              if (bodyEl) bodyEl.textContent = parts[1] || parts[0] || origBody;
            } else {
              var bodyEl = document.getElementById('rev-body-' + id);
              if (bodyEl) bodyEl.textContent = result;
            }
            btn.textContent = i18n.showOriginal;
            translated = true;
          })
          .catch(function () { clearTimeout(killer); btn.textContent = i18n.translate; });
      });
    });
  }

  function bindImageBtns() {
    document.querySelectorAll('.rev-img-btn').forEach(function(btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function() {
        var imgs = JSON.parse(btn.dataset.imgs);
        openLightbox(imgs, parseInt(btn.dataset.idx));
      });
    });
  }

  function setHelpfulState(btn, voted, count) {
    btn.style.color = voted ? '#2e7d32' : '#aaa';
    btn.style.borderColor = voted ? '#2e7d32' : '#ddd';
    var countEl = document.getElementById('rev-helpful-count-' + btn.dataset.id);
    if (count > 0) {
      if (countEl) {
        countEl.textContent = count;
      } else {
        btn.insertAdjacentHTML('beforeend', '<span id="rev-helpful-count-' + btn.dataset.id + '" style="font-size:11px;margin-left:3px">' + count + '</span>');
      }
    } else if (countEl) {
      countEl.remove();
    }
  }

  function bindHelpful() {
    document.querySelectorAll('.rev-helpful-btn').forEach(function (btn) {
      var id = parseInt(btn.dataset.id);
      // Pradinė būsena iš serverio (voted grąžina API), ne iš localStorage — todėl
      // teisinga ir kitam įrenginy/naršyklėj, ir po slapukų valymo.
      if (btn.dataset.voted === '1') setHelpfulState(btn, true, parseInt((document.getElementById('rev-helpful-count-' + id) || {}).textContent || '0'));
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function () {
        btn.style.opacity = '0.5';
        fetch(API + '/reviews/helpful/' + id, { method: 'POST' })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            btn.style.opacity = '1';
            votedIds[id] = !!data.voted;
            saveVoted(id, data.voted);
            setHelpfulState(btn, data.voted, data.helpful_count || 0);
          })
          .catch(function () { btn.style.opacity = '1'; });
      });
    });
  }

  window.LipsellReviews = {
    init: function () { load(false); }
  };
})();
